import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { IconX } from "@tabler/icons-react";
import { ModalHeader } from "./shared/ModalHeader";
import { cn } from "@/lib/utils";

type CustomDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  desc?: string;
  children: React.ReactNode;
  headerStart?: React.ReactNode;
  contentClassName?: string;
  bodyClassName?: string;
  hideHeader?: boolean;
  hideDivider?: boolean;
  hideCloseButton?: boolean;
};

export const CustomDialog = ({
  open,
  onOpenChange,
  title,
  desc,
  children,
  headerStart,
  contentClassName,
  bodyClassName,
  hideHeader = false,
  hideDivider = false,
  hideCloseButton = false,
}: CustomDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className={cn(
          "z-50 flex max-h-[90vh] w-[min(100vw-32px,520px)] max-w-none flex-col gap-0 overflow-hidden rounded-3xl border-0 bg-white p-0 pb-0 shadow-xl sm:rounded-3xl",
          contentClassName,
        )}
      >
        {!hideCloseButton ? (
          <DialogClose className="absolute right-4 top-4 z-20 icon-bg">
            <IconX stroke={2} size={20} />
            <span className="sr-only">Close</span>
          </DialogClose>
        ) : null}

        {hideHeader ? (
          <DialogTitle className="sr-only">{title || "Dialog"}</DialogTitle>
        ) : null}

        {!hideHeader ? (
          <ModalHeader
            title={title}
            description={desc}
            headerStart={headerStart}
            isSheet={false}
          />
        ) : null}

        {!hideDivider ? <div className="border-t" /> : null}

        <div
          className={cn(
            "tovtrip-scrollbar flex flex-col min-h-0 flex-1 overflow-x-hidden overflow-y-auto pb-6",
            bodyClassName,
          )}
        >
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
};
